<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-row>
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายละเอียดการนับสต๊อก</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
                    <section class="d-flex justify-space-between">
                        <v-row>
                            <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6" class="content-header-title"></v-col>
                            <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                                <div class="mt-1">
                                    <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify"
                                        hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined dense>
                                    </v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </section>

                    <section class="pa-3" v-if="page_number == 1">
                        <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props"
                            mobile-breakpoint="0">
                            <template v-slot:item="dataDetail">
                                <tr>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.product_code }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.product_name }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.quantity }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.unit_name }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.quantity_count }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.before_change }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.after_change }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.user_confirm_name }}</div>
                                    </td>
                                    <td>
                                        <div class="d-flex">
                                            <span>
                                                <v-btn v-if="dataDetail.item.count_status == 1" elevation="4"
                                                    class="ma-3 font-16" outlined color="#88B358" title="ตรวจสอบการนับสต๊อก"
                                                    style="border-radius:10px"
                                                    @click="link('/arin/pos/countingstockcheck')">
                                                    <v-icon>mdi-checkbox-marked-circle</v-icon> ตรวจสอบการนับสต๊อก
                                                </v-btn>
                                            </span>
                                            <span v-if="dataDetail.item.count_status == 2">
                                                <v-btn elevation="4" class="ma-3 font-16" outlined color="#8EBBDC"
                                                    title="ดูรายละเอียด" style="border-radius:10px"
                                                    @click="link('/arin/pos/countingstockdetail')">
                                                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                                                </v-btn>
                                            </span>
                                            <!-- @click="edit_count_lot(dataDetail.item.id)" -->
                                            <span v-if="dataDetail.item.count_status == 0">
                                                <v-btn elevation="4" class="ma-3 font-16 mx-0" outlined color="#FEA06C"
                                                    title="แก้ไขรอบนับ" style="border-radius:10px"
                                                    @click="link('/arin/pos/countingstockedit/' + dataDetail.item.id)">
                                                    <v-icon>mdi-pencil</v-icon> แก้ไขรอบนับ
                                                </v-btn>
                                            </span>
                                            <span v-if="dataDetail.item.count_status == 0">
                                                <v-btn elevation="4" class="ma-3 font-16 " outlined color="#B0886B"
                                                    title="ปิดรอบ" style="border-radius:10px"
                                                    @click="dialog_cancel_order_dialog(dataDetail.item.id)">
                                                    <v-icon>mdi-lock-clock</v-icon> ปิดรอบ
                                                </v-btn>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </section>
                </v-card>
            </div>
        </div>
    </div>
</template>
  
<script>
import cancel_order from "@/assets/checked_refund.png";
import { minDate } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Admin_list",
    data() {
        return {
            loading_page: false,
            img_cancel_order: cancel_order,
            dialog_cancel_order: false,
            data_cancel: '',
            page_number: 1,
            search: '',
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            headers: [
                {
                    text: 'รหัสสินค้า',
                    value: 'product_code',
                    fixed: true,
                },
                {
                    text: 'ชื่อสินค้า',
                    value: 'product_name',
                    fixed: true,
                },
                {
                    text: 'จำนวนคลัง',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'หน่วย',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'นับได้',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'ส่วนต่างก่อนปรับ',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'ส่วนต่างหลังปรับ',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'ผู้ปรับส่วนต่าง',
                    value: '',
                    fixed: true,
                    sortable: false,
                },
            ],
            data_list: [],
            counting_check: null,
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'นับสต๊อก',
                    disabled: false,
                },
                {
                    text: 'รายละเอียดการนับสต๊อก',
                    disabled: false,
                    href: '#',
                },
            ],
            menu_date: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateEN: '',
            start_date: this.min_date(),
            money_list: [
                { id: 1, name: 'Stock' },
                { id: 2, name: 'Stock2' },
            ],
        }
    },
    methods: {
        dialog_cancel_order_dialog(id) {
            this.dialog_cancel_order = true;
            this.data_cancel = id;
        },
        cancel_counting_stock() {
            // count_status
            let send_data = {
                id: this.data_cancel,
                count_status: 2,
            }
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            };
            HTTP_ARIN.post('/countstock/store/update/status', send_data, config)
                .then((res) => {
                    if (res.data.successful === true) {
                        let timerInterval
                        Swal.fire({
                            title: 'เสร็จสิ้น',
                            text: 'แก้ไขข้อมูลเรียบร้อย',
                            icon: 'success',
                            timer: 2000,
                            timerProgressBar: true,
                            didOpen: () => {
                                Swal.showLoading()
                                timerInterval = setInterval(() => { }, 100)
                            },
                            willClose: () => {
                                clearInterval(timerInterval)
                                setTimeout(function () {
                                    window.location.reload();
                                });
                            }
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'แจ้งเตือน',
                            text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                            icon: 'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: `ตกลง`,
                            denyButtonText: `ยกเลิก`,
                        })
                    }
                })
        },
        link(link) {
            window.location.href = link;
        },
        edit_employee() {
            this.$router.push('/arin/adminlist/editemployee')
        },
        detail_employee() {
            this.$router.push('/arin/adminlist/detailemployee')
        },
        async page(type) {
            // this.loading_page = true
            this.page_number = type
        },
        min_date: function () {
            return minDate()
        },
        async selectDate() {
            this.$refs.menu_date.save(this.date)
            this.menu_date = false
        },
        diffDateTH(value) {
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            return this.date = final_date
        },
        diffDateEN() {
            const diff = this.date.split('-')
            const year = parseInt(diff[2]) - 543
            const month = diff[1]
            const day = diff[0]
            return year + '-' + month + '-' + day
        },
        getCountingList() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/countstock/store/get/count/product/list/' + this.$route.params.id, config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false;
                    this.data_list = res.data.message;
                }
            })
        },
    },
    created() {
        const diff = this.date.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0]) + 543
        const final_date = day + '/' + month + '/' + year
        return this.date = final_date
    },
    mounted() {
        this.getCountingList();
    }
}
</script>
  
<style scoped>
.v-timeline::before {
    top: 55px;
    height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
    background-color: #D6BFAF;
    width: 4px;
}

/* .header-content {
    margin-left: -45px;
    background: #f1e9e3;
    border: 1px solid #f1e9e3;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0 30px 30px 0;
  } */
.content-font {
    color: #616A6B;
    font-weight: 500;
    font-size: 16px;
}

.logo_timeline {
    width: 25px;
    height: 25px;
}

.logo_timeline>img {
    max-width: 25px;
}

.text_title {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.grid_half {
    display: grid;
    grid-template-columns: 45% 55%;
}

.radio_half {
    display: grid;
    grid-template-columns: 50%;
}

.v-otp-input .v-input {
    padding: 10px !important
}

.input-radius {
    border-radius: 10px;
}

.grid_radio {
    display: flex;
    justify-content: space-between;
}

.btn_width {
    width: 50%;
}

.image_half {
    display: grid;
    grid-template-columns: 40% 60%;
}

.input_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.mobile_btn {
    width: 15%;
}

.file_input_style {
    position: absolute;
    top: -25px;
    left: 265px;
    right: 0;
    bottom: 0;
}

.preview {
    border-radius: 10px;
    display: inline-block;
}

.logo_admin {
    width: 80px;
    height: 80px;
}

.logo_admin>img {
    max-width: 80px;
}

.btn_width {
    width: 50%;
}

.input-radius {
    border-radius: 10px;
}

.text_header {
    color: #616A6B;
    font-weight: bold;
    font-size: 20px;
}

.text_header_title {
    color: #616A6B;
    font-weight: bold;
    font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
    font-size: 16px !important;
}


.text_title {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.input_two_four {
    display: grid;
    grid-template-columns: 20% 40%;
}

.input_four_six {
    display: grid;
    grid-template-columns: 40% 60%;
}

.content-header-title {
    color: #616A6B;
    font-weight: 1000;
    font-size: 20px;
    display: flex;
    align-items: center;
}

.btn_detail_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #0F71B9 0%, rgba(136, 179, 88, 0) 100%), #8EBBDC !important;
    border-radius: 10px;
    width: 100%;
}

.btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100% !important;
}

.btn_add_data_pop {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 135px !important;
}
</style>
  